<template>
  <div class="searchBarLayer" @keydown.stop>
    <div class="searchInputLayer">
      <span v-show="hotTagList.length > 0">热门搜索：</span>
      <nav class="hotSearchContainer">
        <ul class="hotSearch">
          <li
            v-for="(item, index) in hotTagList"
            :key="index"
            @click="selectHotTag(item)"
          >
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </nav>

      <div style="position: relative">
        <input
          ref="input"
          class="searchInput"
          type="text"
          placeholder="搜索关键词"
          v-model="keyWord"
          @keyup.enter="confirmSearch"
          @keyup.delete="deleteSearch"
          @click="track"
          @paste.stop
        />
        <div
          class="clearBtn"
          v-show="showClearBtn"
          @click="deleteKeyWorld"
        ></div>
        <div class="searchBtn" @click="search"></div>
      </div>
    </div>
    <div id="closeBtn" @click="closeDialog">
    </div>
  </div>
</template>

<script>
export default {
  name: "searchBar",
  data() {
    return {
      keyWord: "",
      hotTagList: [],
    };
  },
  props: {
    searchType: "",
  },
  created() {},
  methods: {
    track() {
      sensors.track("searchClick", {
        search_source: "编辑器素材弹窗",
      });
    },
    selectHotTag: function (tag) {
      this.$store.commit("tracking/setTrackingData", {
        keyword_type: "热门推荐词",
      });
      this.keyWord = tag.name;
      this.$emit("search", tag.name);
    },
    search: function () {
      this.$store.commit("tracking/setTrackingData", {
        keyword_type: "手动输入",
      });
      this.$emit("search", this.keyWord);
    },
    closeDialog() {
      this.$emit("pageCloseed");
      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    confirmSearch: function () {
      this.search();
    },
    deleteSearch: function () {
      if (this.keyWord == "" || this.keyWord == null) {
        this.search();
      }
    },
    deleteKeyWorld: function () {
      //this.$refs.input.value = "";
      this.keyWord = "";
      this.search();
      //console.log(this.keyWord);
    },
  },
  mounted() {
    let url = "/api/common/material/recommendTag?type=" + this.searchType;
    this.$http.get(url).then((res) => {
      //console.log("type:" + this.searchType + "   " + JSON.stringify(res.data));
      if (res.data.code == "200" && res.data.data.length > 0) {
        this.hotTagList = res.data.data;
      } else {
        // for (var i = 0; i < 6; i++) {
        //   this.hotTagList.push({ name: "医生" });
        // }
      }
    });
  },
  computed: {
    showClearBtn: function () {
      return (
        this.keyWord != undefined && this.keyWord != "" && this.keyWord != null
      );
    },
  },
};
</script>

<style scoped>
.searchBarLayer {
  background-color: #f0f0f8;
  display: flex;
  justify-content: flex-end;
  margin: 0px;
  position: relative;
  height: 50px;
}

#closeBtn {
  justify-self: end;
  align-self: center;
  width: 16px;
  height: 16px;
  margin: 0px 20px;
  background-image: url(../../../../static/svg/template-material-lib/common/close.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

#closeBtn:hover {
  background-image: url(../../../../static/svg/template-material-lib/common/close-active.svg);
}

.searchInputLayer {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #474261;
}

.hotSearchContainer {
  /* width: 400px; */
  height: 16px;
  overflow: hidden;
}

.hotSearch {
  display: flex;
  align-content: flex-end;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

/* .hotSearchContainer:hover ul {
  animation-play-state: paused;
}
.hotSearch {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 40px;
  animation: moving 6s linear infinite;
}

@keyframes moving {
  0% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-50%);
  }
  80% {
    transform: translateY(-50%);
  }
  100% {
    transform: translateY(0);
  }
} */

.hotSearch li {
  box-sizing: border-box;
  /* min-width: 66px; */
  text-align: center;
  margin: 0 10px;
}

.hotSearch li:hover {
  cursor: pointer;
}

.hotTag {
  display: flex;
}

.searchInput {
  width: 180px;
  height: 32px;
  margin-left: 20px;
  border-radius: 16px;
  padding-left: 12px;
  border: 1px solid #d4d4e7;
  color: #aca8c4;
  font-size: 12px;
}

.searchInput::-webkit-input-placeholder {
  font-size: 12px;
  color: #aca8c4;
}

.searchBtn {
  position: absolute;
  right: 9px;
  top: 9px;
  height: 14px;
  width: 14px;
  background-image: url(../../../../static/svg/template-material-lib/common/search.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.clearBtn {
  position: absolute;
  right: 27px;
  top: 9px;
  height: 14px;
  width: 14px;
  background-image: url(../../../../static/svg/template-material-lib/common/clear-btn.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
</style>

<style>
.searchBar {
  width: 100%;
  margin: 0;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/searchBar.vue